
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import blogByTitle from '@/apollo/queries/blog/blogByTitle';
  import blogSearchMixin from '~/mixins/blogSearchMixin.js';

  export default {
    mixins: [blogSearchMixin],
    layout: 'white',
    middleware: 'redirectInvalidBlog',
    data() {
      return {
        blogs: {
          type: Array,
          default: () => [],
        },
        loading: 0,
        isBlogSideWidgetActive: false,
        isAdvisorBlog: false,
        isDesktop: true,
        advisor: {},
      };
    },
    apollo: {
      $loadingKey: "loading",
      blogs: {
        prefetch: true,
        query: blogByTitle,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , slug: this.$route.params.slug, today: moment().format('YYYY-MM-DD')};
        },
        update(data) {
          return this.$normalizeStrapi(data.blogs.data);
        },
        error(err) {
          console.debug('err: ' , err);
        },
      },
    },

    head() {
      return {
      title: this.blogs[0]?.Metadata?.MetaTitle,
      meta: [
        {
          hid: 'og:title', name: 'og:title', property: 'og:title',
          content: this.blogs[0]?.Metadata?.MetaTitle,
        },
        {
          hid: 'og:description', name: 'og:description', property: 'og:description',
          content: this.blogs[0]?.Metadata?.MetaDescription,
        },
        {
          hid: 'description', name: 'description',
          content: this.blogs[0]?.Metadata?.MetaDescription,
        },
        {
          hid: 'og:image', name: 'og:image', property: 'og:image',
          content: this.blogs[0]?.Metadata?.Image?.url || this.blogs[0]?.BlogInfo?.KeyVisual?.url,
        },
      ]
      }
    },

    computed: {
      ...mapGetters({
        showBlogDisclaimerModal: 'modal/showBlogDisclaimerModal',
        disclaimerConfirmedBlogs: 'disclaimerPopup/disclaimerConfirmedBlogs'
      }),
      BlogFiltersTagCodes () {
          return this.$store.getters['blog/filtersTagCodes']
      },
      BlogFiltersAuthorCodes() {
          return this.$store.getters['blog/filtersAuthorCodes']
      },
      showAdsense() {
        return this.blogs[0]?.blog_objectives.filter((item) => item?.code === 'adsense').length > 0;
      },
      adImageSide1() {
        return this.blogs[0]?.image_banner_ad_lists.filter((item) => item?.c_page_ad_position?.filter?.position_code === 'side1');
      }
    },

    async mounted() {
      const _vue = this // << here
      this.$nextTick(()=>{
        let scrollUpCounter = 0
        let scrollDownCounter = 0
        const scrollUpBuffer = 20
        const scrollDownBuffer = 5
        const scrollDownToHide = 20
        const clientWidth = document.body.clientWidth
        if (clientWidth < 1025) {
          this.$store.commit('blog/setDesktopMenuState', false)
        } else {
          this.$store.commit('blog/setDesktopMenuState', true)
        }

        /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
        let prevScrollpos = window.pageYOffset;
        const el = document.getElementsByClassName("blog-sidebar-layout")
        window.onscroll = function() {
          const clientWidth = document.body.clientWidth
          const currentScrollPos = window.pageYOffset;
          // console.debug('currentScrollPos:',currentScrollPos)

          if (currentScrollPos > prevScrollpos) {
            scrollDownCounter++
            scrollUpCounter = 0

            if ( currentScrollPos < 200 ){
              _vue.showBlogSideWidget(false)
            }

            if ( scrollDownCounter - scrollDownBuffer > scrollDownToHide ){
              _vue.showFullBlogFilter(false)
              scrollUpCounter = 0
            }
          }

          if (prevScrollpos > currentScrollPos) {
            scrollUpCounter++
            scrollDownCounter = 0
            if(scrollUpCounter > 30) {
              _vue.showFullBlogFilter(true)
            }

            if ( checkVisible(el[0]) ){
              if(clientWidth > 400) {
                //
                // _vue.showFullBlogFilter(false)
              }
            }

            if ( currentScrollPos < 5 ){
              if(clientWidth > 1024) {
                _vue.showFullBlogFilter(true)
              }
            }

          } else if ( currentScrollPos > 500 && currentScrollPos < 1500 ){
            // if(clientWidth > 1400) {
            //   _vue.showBlogSideWidget(true)
            // }

          } else {
            _vue.showBlogSideWidget(false)
          }
          prevScrollpos = currentScrollPos;

          // console.debug('scrollUpCounter, scrollDownCounter, currentScrollPos: ',scrollUpCounter, scrollDownCounter, currentScrollPos)
        }

      })

      function checkVisible(elm, threshold, mode) {
        threshold = threshold || 0;
        mode = mode || 'visible';

        if(elm) {
          const rect = elm.getBoundingClientRect();
          const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
          const above = rect.bottom - threshold < 0;
          const below = rect.top - viewHeight + threshold >= 0;

          return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
        }
        return false
      }

      if(!this.disclaimerConfirmedBlogs.includes('blog-auto-'+this.$route?.params?.slug)) {
        const dataObj = {
          modalType: 'blogDisclaimerModal',
          disclaimerType: `blog-auto-${this.$route?.params?.slug}`
        }
        this.setBlogDisclaimerModalData(dataObj)
        this.openBlogDisclaimerModal()
      }

      // Handle screen size changes
      window.addEventListener('resize', this.handleResize);
      // Initial check for resize position (in case the page loads already resized)
      this.handleResize();

      // check if the blog is advisor blog or not
      // const urlParams = new URLSearchParams(window.location.search);
      // this.isAdvisorBlog = urlParams.has('adid');

      /* Controlling display of Advisor Card */
      // check whether the blog has reference code or not
      const refCode = this.$route.query.adid;

      if(refCode) {
        // console.debug("refCode: ", refCode);
        let data;
        try {
          // console.debug('call getAdvisorByRefCode')
          data = await this.$getAdvisorByRefCode(refCode, this.$route.params.slug).then(function(response){
            // console.debug("SUCCESS");
            return response.data;
          });
        }
        catch (ex) {
          console.debug("FAILURE");
          console.debug(`*** advisor fetch error ***`);
          this.isAdvisorBlog = false;
          if (ex.response?.data) {
            console.debug('-- Error Response Data --');
            console.debug(JSON.stringify(ex.response?.data));
          }
          return [];
        }

        if(data.data.length > 0) {
          // console.debug("data: ", data.data)
          let companyTranslations;
          if(data.data[0].attributes.advisor?.data.attributes.type==="Broker")
          {
            companyTranslations = data.data[0].attributes.advisor?.data.attributes.employed_companies?.data[0]?.attributes.employed_company_translations?.data;
          }
          else
          {
            companyTranslations = data.data[0].attributes.advisor?.data.attributes.insurance_companies?.data[0]?.attributes.insurance_company_translations?.data;
          }

          let advisorTranslation = data.data[0].attributes.advisor?.data.attributes.advisor_translation?.data;
          let advisorName = advisorTranslation.attributes.last_name+advisorTranslation.attributes.first_name;
          if(advisorTranslation.attributes.locale!==this.$normalizeLocale(this.$i18n.locale))
          {
            let translationData;
            try {
              // console.debug('call getAdvisorTranslation')
              translationData = await this.$getAdvisorTranslation(advisorTranslation.id).then(function(response){
                // console.debug("SUCCESS");
                return response.data;
              });
            }
            catch (ex) {
              console.debug("FAILURE");
              console.debug(`*** advisor translation fetch error ***`);
              this.isAdvisorBlog = false;
              if (ex.response?.data) {
                console.debug('-- Error Response Data --');
                console.debug(JSON.stringify(ex.response?.data));
              }
              return [];
            }
            advisorTranslation = translationData.data.attributes.localizations.data[0];
            advisorName = advisorTranslation.attributes.first_name+' '+advisorTranslation.attributes.last_name;
          }

          // console.debug('translations: ');
          // console.debug(companyTranslations)
          const company = companyTranslations.filter((translate) => {
            // console.debug(translate);
            return translate.attributes.locale===this.$normalizeLocale(this.$i18n.locale);
          }).at(0);
          // console.debug(company);
          this.advisor = {
            advisorProfilePicture: data.data[0].attributes.advisor?.data.attributes.profile_picture?.data.attributes.url,
            advisorName,
            advisorCompany: company.attributes.name,
            advisorProfile: data.data[0].attributes.advisor?.data.attributes.advisor_translation?.data.attributes.about,
            advisorContact: (String)(data.data[0].attributes.advisor?.data.attributes.mobile_no),
            advisorId: data.data[0].attributes.advisor?.data.id,
            advisorRegistrationNo: data.data[0].attributes.advisor?.data?.attributes?.registration_no,
          }

          this.isAdvisorBlog = true;
        }
        else {
          this.isAdvisorBlog = false;
          // this.$router.push({path: this.localePath('/' + this.$i18n.locale + '/404/')})
        }
      }
      // console.debug(this.isAdvisorBlog);
    },

    beforeDestroy() {
      // Remove the resize event listener when the component is destroyed
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      updateTagCodes(event){
        this.filters = event.filters;
      },
      showBlogSideWidget(boolean) {
        this.isBlogSideWidgetActive = boolean
      },
      showFullBlogFilter(boolean) {
        this.$store.commit('blog/setDesktopMenuState', boolean)
      },
      openBlogDisclaimerModal() {
        this.$store.commit('modal/setShowBlogDisclaimerModal', true);
      },
      setBlogDisclaimerModalData(dataObj) {
        const obj = {
          modalType: dataObj.modalType,
          disclaimerType: dataObj.disclaimerType,
        }
        this.$store.commit(`modal/setBlogDisclaimerModalData`, obj);
      },
      closeBlogDisclaimerModal() {
        this.$store.commit('modal/setShowBlogDisclaimerModal', false);
      },
      handleResize() {
        // Check if the screen width is smaller than a certain threshold
        const isDesktop = window.innerWidth > 1024;

        // Set isDesktop based on the screen width and height
        this.isDesktop = isDesktop;
      },
    },
  }
